import { render } from "./OhmCalculator.vue?vue&type=template&id=0671e1f4"
import script from "./OhmCalculator.vue?vue&type=script&lang=js"
export * from "./OhmCalculator.vue?vue&type=script&lang=js"

import "./OhmCalculator.vue?vue&type=style&index=0&id=0671e1f4&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__